import { render, staticRenderFns } from "./NotificationsListElement.vue?vue&type=template&id=142ccb04&scoped=true"
import script from "./NotificationsListElement.vue?vue&type=script&lang=js"
export * from "./NotificationsListElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ccb04",
  null
  
)

export default component.exports